import {FC} from 'react';
import {Outlet} from "react-router-dom";

const LayoutWithoutBar: FC<{}> = () => {
    return (
        <Outlet/>
    );
};

export default LayoutWithoutBar;
